module.exports = __webpack_public_path__ + "assets/Group 10998.316cc482.svg";